<template>
  <div>
    <vs-row>
      <sm-hateoas-filters ref="onFilter" horizontal visible v-if="filterResource" :filters="filters" :filter-resource="filterResource" @filters-change="onFilterChange"></sm-hateoas-filters>
    </vs-row>
    <vs-row>
      <vs-col :vs-w="showFiltersTransition ? 9 : 12" class="p-2">
        <vx-card v-if="members"
                v-show="filterValues">
          <div :class="'flex justify-end'" >
            <div class="pr-2"><vs-button :disabled="disableDownloadButton"
                        type="filled"
                        color="success"
                        @click="batchDownload()"
                        class="w-full">{{ $t('member_reports.buttons.batch_Download') }}
                      </vs-button></div>
          </div>

          
          <sm-hateoas-table
            ref="membersTable"
            @selected="handleSelected"
            :paged-resources="members"
            :relation="'member-reports'"
            :search="true"
            :pagination="true"
            @updatePageSize="updatePageSize"
            @updateMembersData="updateMembersData"
            @updatePageIndex="updatePageIndex"
            :filters="filterValues">
            <template slot="thead">
            <vs-th width="5%">
              <vs-checkbox :checked="selectAll" @change="selectAllMembers()"/>
            </vs-th>
            <vs-th sort-key="user.firstName" width="15%">
              {{ $t('member_reports.columns.starling_hq_user') }}
            </vs-th>
            <vs-th sort-key="referral.name" width="15%">
              {{ $t('member_reports.columns.referral') }}
            </vs-th>
            <vs-th sort-key="user.id" width="5%">
              {{ userIdLabel }}
            </vs-th>
            <vs-th sort-key="referral.acceptance.accepted" width="15%">
              {{ $t('member_reports.columns.accepted') }}
            </vs-th>
            <vs-th sort-key="createdDate" width="15%">
              {{ $t('member_reports.columns.report_date') }}
            </vs-th>
            <vs-th sort-key="lastDownloadDate" width="15%">
              {{ $t('member_reports.columns.last_download') }}
            </vs-th>
            <vs-th sort-key="lastDownloadBy" width="15%">
              {{ $t('member_reports.columns.last_downloaded_by') }}
            </vs-th>
            <vs-th sort-key="downloadCount" width="10%">
              {{ $t('member_reports.columns.downloaded') }}
            </vs-th>
            </template>

            <template slot-scope="{data}">
            <vs-tr :data="tr" :key="data[indextr].id" v-for="(tr, indextr) in data">

              <vs-td>
                <vs-checkbox v-model="selectedValues[indextr]" @change="itemSelected(data[indextr])"/>
              </vs-td>

              <vs-td :data="data[indextr].caseManagerName">
                <div>
                  <span>{{data[indextr].caseManagerName}}</span>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].$getEmbedded('referral').$getEmbedded('referral-claimant').firstname">
                <span @click="viewReferral(data[indextr])" style="color: #1E77B7">{{ data[indextr].$getEmbedded('referral').$getEmbedded('referral-claimant').firstname }} {{ data[indextr].$getEmbedded('referral').$getEmbedded('referral-claimant').lastname }}</span>
              </vs-td>

              <vs-td v-if="data[indextr].claimNumber" :data="data[indextr].claimNumber">
                <span>{{data[indextr].claimNumber}}</span>
              </vs-td>
              <vs-td v-else>
                --
              </vs-td>

              <vs-td v-if="data[indextr].acceptedDate" :data="data[indextr].acceptedDate">
                {{ formatDatetoUTC(data[indextr].acceptedDate) }} 

              </vs-td>
              <vs-td v-else>
                --
              </vs-td>

              <vs-td :data="data[indextr].createdDate">
                {{ formatDatetoUTC(data[indextr].createdDate) }} 
              </vs-td>

              <vs-td v-if="data[indextr].lastDownloadDate" :data="data[indextr].lastDownloadDate">
                {{ formatDatetoUTC(data[indextr].lastDownloadDate) }} 
              </vs-td>
              <vs-td v-else>
                --
              </vs-td>

              <vs-td :data="data[indextr].lastDownloadBy">
                <span>{{data[indextr].lastDownloadBy ? data[indextr].lastDownloadBy !== profileName ? data[indextr].lastDownloadBy : 'Me' : '--'}}</span>
              </vs-td>

              <vs-td>
                <span>{{data[indextr].downloadCount ? data[indextr].downloadCount : 0}}</span>
              </vs-td>

            </vs-tr>
            </template>
          </sm-hateoas-table>
        </vx-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import SmHateoasTable from '@/components/starling/sm-hateoas-table/sm-hateoas-table';
import {ResourceImpl} from 'hal-client';
import SmHateoasFilters from '@/components/starling/sm-hateoas-filters/sm-hateoas-filters';
import moment from 'moment';

/* eslint-disable security/detect-object-injection */
export default {
  name: 'member-reports',
  now: new Date(),
  components: {
    SmHateoasFilters,
    SmHateoasTable,
    moment
  },
  props: {
    memberReportsResource: {
      type: ResourceImpl,
      required: true
    }
  },
  data () {
    return {
      members: this.memberReportsResource,
      filters: null,
      filterValues: null,
      showFiltersTransition: false,
      refreshKey: 0,
      intervalId: null,
      userIdLabel : null,
      tempSelected: false,
      filterResource: null,
      selectedValues: [],
      selectedIdsMap: new Map(),
      selectAll: false,
      pageSize: 0,
      pageIndex: 0,
      profileName: null,
      pages: new Map(),
      disableDownloadButton: true,
      membersData: null
    };
  },
  mounted () {
    this.profileName = this.$store.state.router.profileResource.fullname;
    this.members.$request().$get('user-id-label', null, {locale:'en'}).then((res) => {
      this.userIdLabel = res.state().label;
      if (!this.userIdLabel) {
        this.userIdLabel = this.$t('view_member.block.report.fields.user_id');
      }
    });
    if (this.members.$hasLink('filters')) {
      this.members.$request().$get('filters').then(res => {
        this.filters = res.$getEmbedded('filters');
        this.filterResource = res;
      });
    }
  },
  methods: {
    itemSelected (member) {
      this.selectAll = false;
      this.pages.set(this.pageIndex, {selectedValues: this.selectedValues, selectAll: this.selectAll});
      this.addOrRemoveFromSelectedIdsMap(member, !this.selectedIdsMap.has(member.id));
    },
    selectAllMembers () {
      this.selectAll = !this.selectAll;
      const tempSize = this.pageSize > 0 ? this.pageSize : this.members.$getEmbedded('member-reports').length;
      const membersTemp = this.membersData ? this.membersData : this.members.$getEmbedded('member-reports');
      for (let i = 0; i <= tempSize; i++) {
        this.selectedValues[i] = this.selectAll;
        this.addOrRemoveFromSelectedIdsMap(membersTemp[i], this.selectAll);
      }
      this.pages.set(this.pageIndex, {selectedValues: this.selectedValues, selectAll: this.selectAll});
    },
    updatePageSize (size) {
      this.selectedIdsMap = new Map();
      this.pages = new Map();
      this.selectedValues = [];
      this.selectAll = false;
      this.pageSize = size;
      this.pageIndex = 0;
    },
    updateMembersData (size, members, isFilter) {
      this.membersData = members;
      this.pageSize = size;
      if (isFilter) {
        this.selectedIdsMap = new Map();
        this.pages = new Map();
        this.selectedValues = [];
        this.selectAll = false;
        this.pageIndex = 0;
      }
    },
    updatePageIndex (index) {
      this.selectAll = false;
      this.pageIndex = index;
      if (this.pages.has(index)) {
        this.selectedValues = this.pages.get(index).selectedValues;
        this.selectAll = this.pages.get(index).selectAll;
      } else {
        this.selectedValues = [];
        this.selectAll = false;
        this.pages.set(index, {selectedValues: this.selectedValues, selectAll: this.selectAll});
      }
    },
    formatDatetoUTC (date) {
      return moment.utc(moment(date)).format('MMM D, YYYY');
    },
    handleSelected () {
    },
    onFilterChange (filters) {
      this.filterValues = filters;
    },
    refreshTable () {
      this.$refs.membersTable.refresh();
    },
    onUpdateFilterTransition () {
      this.showFiltersTransition = !this.showFiltersTransition;
    },
    onShowFilters () {
      this.$refs.onFilter.onShowFilters();
    },
    viewMember (member) {
      this.$router.push({
        name: 'app-view-member',
        params: {id: member.id}
      });
    },
    viewReferral (member) {
      this.$router.push({
        name: 'app-view-referral',
        params: {id: member.referralId}
      });
    },
    batchDownload () {
      if (!this.selectedIdsMap.size > 0) return;
      const selected = [];
      this.selectedIdsMap.forEach((value, key) => {
        selected.push(key);
      });
       
      const xhr = new XMLHttpRequest();
      xhr.open('GET', this.members.$href('download', {selected}), true);
      xhr.setRequestHeader('Authorization', this.$store.state.account.accessToken);
      xhr.responseType = 'blob';

      xhr.onload = () => {
        if (xhr.status === 200) {
          const fileLink = document.createElement('a');
          fileLink.href = (window.URL || window.webkitURL).createObjectURL(xhr.response, {type: 'application/octet-stream'});
          const contentDisposition = xhr.getResponseHeader('content-disposition');
          const filename = contentDisposition && contentDisposition.indexOf('filename') ? contentDisposition.split('filename="')[1].split('"')[0] : 'member-report.zip';
          fileLink.setAttribute('download', filename);
          document.body.appendChild(fileLink);

          fileLink.click();
          document.body.removeChild(fileLink);
        }
      };
      xhr.send();
    },
    addOrRemoveFromSelectedIdsMap (member, shouldAdd) {
      if (!member) return;
      // build submission list to BE
      if (shouldAdd) {
        this.selectedIdsMap.set(member.id);
      } else {
        this.selectedIdsMap.delete(member.id);
      }
      this.disableDownloadButton = this.selectedIdsMap.size === 0;
    }
  }
};
</script>

<style scoped>

</style>
